<div class="d-flex flex-column recommendation-section">
    <div class="flex-grow-1 overflow-auto pb-2">
        <div class="px-2">
            @if(isLoading) {
            <div class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <p class="text-muted fw-medium">
                        Generating recommended medications...
                    </p>

                </div>
            </div>
            } @else {
            <div *ngIf="!showAddForm && medications.length === 0"
                class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <img src="{{ cvaUI_url + '/assets/icons/medications.svg' }}" alt="Medication List"
                        aria-hidden="true" class="icon-sm ico-task">

                    <p class="text-muted">
                        You don't have any medications yet.
                    </p>
                </div>
            </div>
            <div *ngIf="medications.length" class="list-group list-group-flush">
                <div *ngFor="let medication of medications; let i = index; trackBy: trackByIndex">
                    <div class="border rounded p-2 mb-2 shadow-sm bg-white"
                        [ngClass]="{'border-red': medication.hasError}">
                        <div class="d-flex align-items-start gap-2">
                            @if(!medication.isSaved){
                            <input type="checkbox" (keydown.space)="toggleCheckbox(i)" (click)="toggleCheckbox(i)"
                                class="cursor-pointer form-check-input mt-1 custom-check-input" name="checkmark"
                                [checked]="medication.checked" />
                            }

                            <div class="flex-grow-1 " [ngClass]="{'ml-1-25':medication.isSaved}">
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                    @if(medication.isSaved){
                                    <span class="badge bg-custom-gray text-black border fw-medium badge-truncate"
                                        [title]="medication.selectedMedicine?.genericName">
                                        {{ medication.selectedMedicine?.genericName }}
                                    </span>
                                    <div class="d-flex justify-content-end ">
                                        <span class="badge bg-success fs-xx-small fw-medium">
                                            <i class="bi bi-check-circle-fill"></i> Medication Added
                                        </span>
                                    </div>
                                    }@else{
                                    <div class="mb-2" style="max-width: 300px;">
                                        <select class="form-select form-select-sm small w-100"
                                            [compareWith]="compareByDrugCode" [(ngModel)]="medication.selectedMedicine"
                                            [name]="'selectedDrugCode_'+i" [id]="'selectedDrugCode_'+i"
                                            #selectCtrl="ngModel" [ngClass]="{
        'is-invalid': medication.checked && (selectCtrl.touched || isSaveAttempted) && selectCtrl.invalid
        }" required>
                                            <option [ngValue]="undefined" disabled selected hidden>
                                                {{medication.medication}}
                                            </option>
                                            <option *ngFor="let med of medication.options" [ngValue]="med">{{
                                                med.genericName }}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback d-block"
                                            *ngIf="medication.checked && (selectCtrl.touched || isSaveAttempted) && selectCtrl.invalid">
                                            Please select a medication.
                                        </div>
                                    </div>
                                    }
                                </div>
                                <div class="small mt-2">
                                    @if(medication.isSaved){
                                    <p class="mb-0 text-black lh-sm ml-2 text-break">{{ medication.dosageInstruction }}
                                    </p>
                                    }@else {
                                    <input type="text" name="add_dosage"
                                        class="form-control form-control-sm small input-box" maxlength="200"
                                        placeholder="Enter dosage instruction..."
                                        [(ngModel)]="medication.dosageInstruction" required #dosageCtrl="ngModel"
                                        [ngClass]="{
        'is-invalid': medication.checked && (dosageCtrl.touched || isSaveAttempted) && dosageCtrl.invalid
        }" />
                                    <div class="invalid-feedback d-block"
                                        *ngIf="medication.checked && (dosageCtrl.touched || isSaveAttempted) && dosageCtrl.invalid">
                                        Dosage instruction is required.
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div *ngIf="showAddForm" class="task-form border rounded shadow-sm p-2 mb-2 bg-white">

                <div class="d-flex justify-content-between align-items-start">
                    <h5 class="text-dark fw-semibold small mb-2 mb-sm-1">New Medication</h5>
                    <button type="button" class="btn btn-sm btn-link p-0" (click)="showAddForm = !showAddForm"
                        title="Close form">
                        <i class="bi bi-x-circle text-grey"></i>
                    </button>
                </div>
            </div>
            }
        </div>
        <span #bottom></span>
    </div>

    @if(medications.length){
    <div class="d-flex justify-content-end align-items-center flex-wrap gap-2 px-2 pt-3 pb-1">
        <button type="button" class="btn btn-dark btn-sm" [disabled]="isSubmitDisabled" (click)="postChecked()">
            Post Medication
        </button>
    </div>
    }
</div>